/* OO(2026-10-06 / 10-08)
   1) メニューでブランド名を押したとき、いきなりシリーズ名が並ぶのではなく先頭に「◯◯の全商品」を出す
   2) 商品ページの「ほかのカラー」を、サイズ選びのすぐ上へ動かす
   3) 並び替え（関連性が最も高い／価格の安い順 など）を選んでも何も起きない不具合の直し

   メニューについて: パソコンのプルダウンは ul.header__nav-links が横並び(flex row)の多段組みで、
   その中の div.header__nav--group-link が1列ぶんにあたる。
   ul の直下に入れると「空っぽの列」が1つ増えてしまうので、必ず列の中に入れる。
   管理画面のナビゲーションは触らず、表示するときに足している。 */
(function () {
  'use strict';

  var BRANDS = {
    'OLD ORDER': { url: '/collections/old-order-all-product', label: 'OLD ORDER の全商品' },
    OCAI: { url: '/collections/ocai-all-product', label: 'Ocai の全商品' },
    BBIMP: { url: '/collections/bbimp-all', label: 'BBiMP の全商品' }
  };

  function listAfter(el) {
    var node = el.nextElementSibling;
    while (node && node.tagName !== 'UL') {
      node = node.nextElementSibling;
    }
    return node;
  }

  function addAllLink(head, box, itemClass) {
    if (!head || !box) return;
    var key = head.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
    var brand = BRANDS[key];
    if (!brand) return;
    if (box.querySelector('[data-brandnav-all]')) return;

    var item = document.createElement('li');
    item.className = 'brandnav-all-item' + (itemClass ? ' ' + itemClass : '');

    var link = document.createElement('a');
    link.className = 'menu-link brandnav-all';
    link.href = brand.url;
    link.textContent = brand.label;
    link.setAttribute('data-brandnav-all', '');

    item.appendChild(link);
    box.insertBefore(item, box.firstChild);
  }

  // この入れ物がどのブランドのものかを、上にさかのぼって探す
  function findHead(start) {
    var node = start;
    for (var i = 0; i < 6 && node; i += 1) {
      node = node.parentElement;
      if (!node) return null;
      var cand = node.querySelector(':scope > button, :scope > a');
      if (cand) return cand;
    }
    return null;
  }

  // 「ほかのカラー」をサイズ選びのすぐ上へ動かす
  function placeColors() {
    var box = document.querySelector('[data-brandnav-colors]');
    if (!box || box.getAttribute('data-placed')) return;
    var target = document.querySelector('.product__variant-picker');
    if (!target || !target.parentNode) return;
    box.classList.add('product__block');
    target.parentNode.insertBefore(box, target);
    box.setAttribute('data-placed', '1');
  }

  /* OO(2026-10-08) 並び替えが効かない不具合の直し。
     テーマの並び替えは custom-select.js が「input」のできごとを出し、
     facets.js がそれを拾って一覧を入れ替える作りだが、送られる中身が空になっていて
     並びが変わらない（サイトの住所に ?sort_by= を付けて開けば、ちゃんと並び替わることは確認済み）。
     ここでは、選んだ中身を住所に付けて普通に開き直す。絞り込みの条件は住所に残るのでそのまま引き継がれる。 */
  function onSortPicked(e) {
    var el = e.target;
    if (!el || el.name !== 'sort_by' || !el.value) return;
    var url;
    try {
      url = new URL(window.location.href);
    } catch (err) {
      return;
    }
    if (url.searchParams.get('sort_by') === el.value) return;
    url.searchParams.set('sort_by', el.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function apply() {
    // スマホのメニュー（開くと出てくるパネル）
    document.querySelectorAll('.menu-panel').forEach(function (panel) {
      var head = panel.querySelector('.menu-header');
      if (!head) return;
      addAllLink(head, listAfter(head));
    });

    // パソコンのヘッダーから下りてくるメニュー
    document.querySelectorAll('ul.header__nav-links').forEach(function (nav) {
      var head = findHead(nav);
      if (!head) return;
      var group = nav.querySelector('.header__nav--group-link') || nav;
      addAllLink(head, group, 'header__nav-links-item');
    });

    placeColors();
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    apply();
    document.addEventListener('input', onSortPicked, true);
    document.addEventListener('change', onSortPicked, true);
    // メニューやカラーがあとから作られる作りのときのため、しばらく様子を見て入れ直す
    var tries = 0;
    var timer = setInterval(function () {
      apply();
      tries += 1;
      if (tries >= 10) clearInterval(timer);
    }, 500);
  });
})();